import React from "react";
import { Dialog, DialogContent, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AutoAwesome } from "@mui/icons-material";

export default function MeetingModal({ showMeeting, setShowMeeting }) {

  const handleCloseMeeting = () => setShowMeeting(false);

  return (
    <>
      {/* Custom CSS for HubSpot widget styling */}
      <style>
        {`
          /* HubSpot Meeting Widget Custom Styling */
          .hs-meetings-embed {
            font-family: 'Inter', 'Poppins', sans-serif !important;
          }
          
          .hs-meetings-embed iframe {
            border-radius: 16px !important;
            box-shadow: 0 20px 60px rgba(53, 103, 214, 0.15) !important;
          }
          
          /* Override HubSpot default colors */
          .hs-meetings-embed * {
            font-family: 'Inter', 'Poppins', sans-serif !important;
          }
          
          /* Style buttons to match IntroPage */
          .hs-meetings-embed button,
          .hs-meetings-embed .hs-button,
          .hs-meetings-embed input[type="submit"] {
            background: linear-gradient(135deg, #3567D6 0%, #5B8DEF 100%) !important;
            border-radius: 8px !important;
            font-family: 'Inter', sans-serif !important;
            font-weight: 600 !important;
            border: none !important;
            box-shadow: 0 4px 20px rgba(53, 103, 214, 0.3) !important;
            transition: all 0.3s ease !important;
          }
          
          .hs-meetings-embed button:hover,
          .hs-meetings-embed .hs-button:hover,
          .hs-meetings-embed input[type="submit"]:hover {
            background: linear-gradient(135deg, #2a57c4 0%, #4a7de0 100%) !important;
            box-shadow: 0 6px 28px rgba(53, 103, 214, 0.4) !important;
            transform: translateY(-2px) !important;
          }
          
          /* Style form inputs */
          .hs-meetings-embed input[type="text"],
          .hs-meetings-embed input[type="email"],
          .hs-meetings-embed input[type="tel"],
          .hs-meetings-embed textarea,
          .hs-meetings-embed select {
            border-radius: 8px !important;
            border: 1px solid #e2e8f0 !important;
            font-family: 'Inter', sans-serif !important;
            padding: 12px 16px !important;
            transition: all 0.3s ease !important;
          }
          
          .hs-meetings-embed input[type="text"]:focus,
          .hs-meetings-embed input[type="email"]:focus,
          .hs-meetings-embed input[type="tel"]:focus,
          .hs-meetings-embed textarea:focus,
          .hs-meetings-embed select:focus {
            border-color: #3567D6 !important;
            box-shadow: 0 0 0 3px rgba(53, 103, 214, 0.1) !important;
            outline: none !important;
          }
          
          /* Style headings */
          .hs-meetings-embed h1,
          .hs-meetings-embed h2,
          .hs-meetings-embed h3 {
            font-family: 'Poppins', sans-serif !important;
            color: #111827 !important;
            font-weight: 700 !important;
          }
          
          /* Style text */
          .hs-meetings-embed p,
          .hs-meetings-embed span,
          .hs-meetings-embed label {
            font-family: 'Inter', sans-serif !important;
            color: #4B5563 !important;
          }
          
          /* Style time slots */
          .hs-meetings-embed .time-slot,
          .hs-meetings-embed [class*="time"] {
            border-radius: 8px !important;
            border: 1px solid #e2e8f0 !important;
            transition: all 0.3s ease !important;
          }
          
          .hs-meetings-embed .time-slot:hover,
          .hs-meetings-embed [class*="time"]:hover {
            border-color: #3567D6 !important;
            background: rgba(53, 103, 214, 0.05) !important;
          }
          
          /* Style selected time slot */
          .hs-meetings-embed .time-slot.selected,
          .hs-meetings-embed [class*="time"].selected {
            background: linear-gradient(135deg, #3567D6 0%, #5B8DEF 100%) !important;
            border-color: #3567D6 !important;
            color: white !important;
          }
          
          /* Style calendar */
          .hs-meetings-embed .calendar,
          .hs-meetings-embed [class*="calendar"] {
            border-radius: 12px !important;
          }
          
          /* Remove default HubSpot branding colors */
          .hs-meetings-embed [style*="background-color: #ff7a59"],
          .hs-meetings-embed [style*="background-color: #ff7a59"] {
            background: linear-gradient(135deg, #3567D6 0%, #5B8DEF 100%) !important;
          }
        `}
      </style>

      <Dialog
        open={showMeeting}
        onClose={handleCloseMeeting}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
            maxHeight: "90vh",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #3567D6 0%, #5B8DEF 100%)",
            padding: { xs: "20px 24px", sm: "24px 32px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <AutoAwesome sx={{ fontSize: "24px", color: "#fff" }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontSize: { xs: "20px", sm: "24px" },
                  fontWeight: 700,
                  color: "#fff",
                  lineHeight: 1.2,
                }}
              >
                Schedule a Demo
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: { xs: "12px", sm: "14px" },
                  color: "rgba(255, 255, 255, 0.9)",
                  marginTop: "4px",
                }}
              >
                Book a time that works for you
              </Typography>
            </Box>
          </Box>

          <IconButton
            aria-label="close"
            onClick={handleCloseMeeting}
            sx={{
              color: "#fff",
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
              width: { xs: "36px", sm: "40px" },
              height: { xs: "36px", sm: "40px" },
              transition: "all 0.3s ease",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.3)",
                transform: "rotate(90deg)",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: { xs: "20px", sm: "24px" } }} />
          </IconButton>
        </Box>

        {/* HubSpot Meeting Embed */}
        <DialogContent
          sx={{
            padding: { xs: "24px", sm: "32px" },
            backgroundColor: "#f8fafc",
            minHeight: { xs: "500px", sm: "600px" },
            position: "relative",
            "&.MuiDialogContent-root": {
              paddingTop: { xs: "24px", sm: "32px" },
            },
          }}
        >
          <Box
            className="hs-meetings-embed"
            sx={{
              width: "100%",
              minHeight: "500px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(53, 103, 214, 0.15)",
              "& iframe": {
                width: "100%",
                minHeight: "500px",
                border: "none",
                borderRadius: "16px",
              },
            }}
          >
            <iframe
              src="https://meetings.hubspot.com/shweta26"
              width="100%"
              height="600"
              frameBorder="0"
              style={{
                border: "none",
                borderRadius: "16px",
                minHeight: "500px",
              }}
              title="Schedule a meeting"
              allow="camera; microphone; fullscreen; display-capture"
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
